import parentApi from '@parent/api/index.js';

let memberUserInfos = null;
try {
  memberUserInfos = JSON.parse(localStorage.getItem('memberUserInfos'));
} catch (err) {
  console.error(err);
}

export default new Vuex.Store({
  state: {
    // 全局按‘课时/次’的单位
    lessonUnit: '课时',
    userInfo: {},
    mallCompanyList: [],
    memberUserInfos,
  },
  mutations: {
    updataLessonUnit(state, val) {
      state.lessonUnit = val;
    },
    updataUserInfo(state, val) {
      state.userInfo = val;
    },
    updataMemberUserInfos(state, val) {
      state.memberUserInfos = val;
      localStorage.setItem('memberUserInfos', JSON.stringify(val));
    },
  },
  actions: {
    // 获取用户信息
    queryUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        parentApi.parentGet({
          appType: app.parent.app_type
        }).then(res => {
          if (res.code === 200) {
            let userInfo = res.data;

            state.lessonUnit = userInfo.businessInfo.lessonUnit || '课时';

            if (userInfo) {
              if (userInfo.companyList) {
                state.mallCompanyList = userInfo.companyList;
              }
              if (!userInfo.thirdAppId || userInfo.thirdAppId == 'null') {
                userInfo.thirdAppId = '';
              }
              if (!userInfo.wxOpenId || userInfo.wxOpenId == 'null') {
                userInfo.wxOpenId = '';
              }

              state.userInfo = userInfo;
              app.parent.user = userInfo;
            }

            resolve(userInfo);
          } else {
            reject(res.msg);
          }
        });
      });
    },
    // 获取用户信息
    queryMemberGetMemberInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        parentApi.memberGetMemberInfo({ studentId: id }).then(res => {
          if (res.code === 200) {
            let data = Object.assign(res.data, { studentId: id });
            commit('updataMemberUserInfos', data);
            resolve(data);
          } else {
            reject(res.msg);
          }
        });
      });
    },
    studentShare({ state }, opts) {
      if (!state.userInfo.isOpenMember) {
        reject({ msg: '未该机构未开通会员' });
      }
      return new Promise((resolve, reject) => {
        parentApi.studentShare(opts).then(res => {
          if (res.code === 200) {
            resolve(res.data);
          } else {
            reject(res.msg);
          }
        });
      });
    },
  },
});
